<div class="mtn-container">
    <div class="mtn-title">
        <p>{{ moduleName?.toUpperCase() }}</p>
    </div>
    <div *ngIf="showForm" class="form-content">
        <form [formGroup]="forms.filterLovForm" class="form">
            <div class="form-container-grid top-form">
                <div class="field required">
                    <label>Client Group</label>
                </div>
                <div class="">
                    <input formControlName="clientCdDisp">
                    <button matSuffix class="btn btn-search" type="button" (click)="openLov['clientType']()"
                        [disabled]="btns.filterLov.clientGrpSearchDisabled" >
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <div class="field required">
                    <label>Subline</label>
                </div>
                <div class="">
                    <input formControlName="sublineCdDisp">
                    <button matSuffix class="btn btn-search" type="button" (click)="openLov['subline']()"
                        [disabled]="btns.filterLov.sublineSearchDisabled" >
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
            </div>
        </form>
    </div>
    <osp-table [tblConfig]="defaultTowingLimitTblConfig" (onRowClick)="onRowClick($event)" [selectedRow]="selectedRow"></osp-table>
    <div id="default-towing-limit-maintenance-loading">
        <div class="form-loader"></div>
    </div>
    <div *ngIf="showForm" class="form-content">
        <form [formGroup]="forms.defaultTowingLimitForm" class="form">
            <div id="default-towing-limit-error-message"></div>
            <div class="form-container-grid">
                <div class="field required">
                    <label>Towing Amount</label>
                </div>
                <div class="">
                    <input class="currency" formControlName="towingAmt" (focus)="_formService.setFieldToNumberWithDecimal(forms.defaultTowingLimitForm, 'towingAmt', $event)"
                    (keypress)="allowNumericDigitsOnly($event)" amount >
                </div>
                <div class="field required">
                    <label>Active</label>
                </div>
                <div class="">
                    <select formControlName="active">
                        <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                            {{activeType.name}}
                        </option>
                    </select>
                </div>
                <div class="field required">
                    <label>Effective Date</label>
                </div>
                <div class="">
                    <input date-input [matDatepicker]="effDatePicker" [max]="maxEffDate" formControlName="effDateFrom" placeholder="MM/DD/YYYY"> 
                    <mat-datepicker-toggle class="mtn-datepicker" matSuffix [for]="effDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #effDatePicker></mat-datepicker>
                </div>
                <div class="field">
                    <label>Expiry Date</label>
                </div>
                <div class="">
                    <input date-input [matDatepicker]="exDatePicker" [min]="minExpDate" formControlName="effDateTo" placeholder="MM/DD/YYYY">
                    <mat-datepicker-toggle matSuffix [for]="exDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #exDatePicker></mat-datepicker>
                </div>
                <div class="field">
                    <label>Remarks</label>
                </div>
                <div class="span">
                    <input formControlName="remarks" >
                </div>
                <div class="field">
                    <label>Last Update User</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdateUser" >
                </div>
                <div class="field">
                    <label>Last Update</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdate" >
                </div>
            </div>
        </form>
        <div class="btn-grp">
            <button *ngIf="btns.defaultTowingLimit.updateDisabled" class="btn btn2" type="button" (click)="onAdd()" [disabled]="btns.defaultTowingLimit.addDisabled" >ADD</button>
            <button *ngIf="!btns.defaultTowingLimit.updateDisabled" class="btn btn2" type="button" (click)="onUpdate()" >UPDATE</button>
            <button class="btn btn2" type="button" [disabled]='btns.defaultTowingLimit.deleteDisabled' (click)="onDelete()" >DELETE</button>
        </div>
        <div class="mtn-title"></div>
        <div class="btn-grp">
            <button class="btn btn2" type="button" [disabled]='btns.defaultTowingLimit.saveDisabled' (click)="onSave()" >SAVE</button>
        </div>
    </div>
</div>
